"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import { Action } from '../Action/Action.mjs';
import { getAriaSelectionMode, getMenuItemSelectionVariant, getCloseOverlayType } from './lib.mjs';
import { Popover } from '../Popover/Popover.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import 'mobx';
import 'react';
import { useOverlayController } from '../../lib/controller/overlay/useOverlayController.mjs';
import { OverlayContextProvider } from '../../lib/controller/overlay/OverlayContextProvider.mjs';
import { ClearPropsContext } from '../ClearPropsContext/ClearPropsContext.mjs';
import '../../lib/propsContext/propsContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import ContextMenuContentView from '../../views/ContextMenuContentView.mjs';
import styles from './ContextMenu.module.scss.mjs';

const ContextMenu = flowComponent("ContextMenu", (props) => {
  const {
    children,
    onAction,
    selectionMode,
    selectedKeys,
    defaultSelectedKeys,
    disabledKeys,
    onSelectionChange,
    ref,
    controller: overlayControllerFromProps,
    ...rest
  } = props;
  const overlayControllerFromContext = useOverlayController("ContextMenu", {
    reuseControllerFromContext: true
  });
  const overlayController = overlayControllerFromProps ?? overlayControllerFromContext;
  const selectionVariant = getMenuItemSelectionVariant(selectionMode);
  const propsContext = {
    MenuItem: {
      selectionVariant,
      Avatar: {
        size: "l"
      }
    },
    Section: {
      MenuItem: {
        Avatar: {
          size: "l"
        }
      },
      renderContextMenuSection: true
    },
    ContextMenuSection: {
      MenuItem: {
        Avatar: {
          size: "l"
        }
      }
    }
  };
  return /* @__PURE__ */ jsx(ClearPropsContext, { children: /* @__PURE__ */ jsx(
    Popover,
    {
      ...rest,
      controller: overlayController,
      isDialogContent: false,
      padding: "s",
      children: /* @__PURE__ */ jsx(
        OverlayContextProvider,
        {
          type: "ContextMenu",
          controller: overlayController,
          children: /* @__PURE__ */ jsx(
            ContextMenuContentView,
            {
              className: styles.contextMenu,
              onAction,
              selectionMode: getAriaSelectionMode(selectionMode),
              selectedKeys,
              defaultSelectedKeys,
              disabledKeys,
              onSelectionChange,
              ref,
              children: /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children: /* @__PURE__ */ jsx(Action, { closeOverlay: getCloseOverlayType(selectionMode), children }) })
            }
          )
        }
      )
    }
  ) });
});

export { ContextMenu, ContextMenu as default };
//# sourceMappingURL=ContextMenu.mjs.map
